import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const { white } = appPalette.colors;
export const useStyles = makeStyles({
  paper: {
    position: 'relative',
    backgroundColor: white,
    width: 'auto',
    height: 'auto',
    border: '0',
    top: '50%',
    left: '0%',
    transform: `translate(0%, -50%)`,
    outline: 'none',
    [theme.breakpoints.up('viewportMedium')]: {
      minHeight: '12.75rem',
      width: '36.625rem',
      height: 'auto',
      backgroundColor: white,
      border: '0',
      top: '50%',
      left: '50%',
      transform: `translate(-50%, -50%)`,
    },
  },
  content: {
    padding: '2.625rem 2rem 2.5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  content_title: {
    marginBottom: '1.875rem',
  },
  content_desc: {
    marginBottom: '1.25rem',
  },
  content_img_container: {
    width: '100%',
    maxWidth: '24.25rem',
    aspectRatio: '18/9',
  },
  content_img: {
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  content_caption: {
    marginBottom: '2.5rem',
  },
  content_actions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('viewportMobileMid')]: {
      flexDirection: 'row',
    },
  },
  content_cta: {
    padding: '0.8125rem 1.25rem',
    width: '14.5625rem',
    marginBottom: '0.4375rem',

    [theme.breakpoints.up('viewportMobileMid')]: {
      marginRight: '1.75rem',
      marginBottom: 0,
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
});
